// extracted by mini-css-extract-plugin
module.exports = {"previewImageModal":"MediaPreviewModal_previewImageModal__9mT27","imageWrapper":"MediaPreviewModal_imageWrapper__61I3u"};